import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {SelectProfileComponent} from "@modules/commom/select-profile/select-profile.component";

const routes: Routes = [
  {
    path: '',
    component: SelectProfileComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class SelectProfileRoutingModule {}
